import { DistrictDataBySchool } from '../../../peekapak-types/ReportDataExchangeTypes';
import SortableTable from '../Tables/SortableTable';
import { getTotalRow } from '../reportUtilities';

interface Props {
  data: DistrictDataBySchool;
  topFiveSchools: string[];
}

const DistrictDataTable = ({ data }: Props) => {
  const columns = [
    {
      label: 'School Name',
      accessor: 'school_name',
      sortable: false,
    },
    {
      label: 'Number of Staff',
      accessor: 'number_of_educators',
      sortable: true,
      tooltip: 'Number of staff at the listed school who have been active during the time period',
    },
    {
      label: 'Staff Logins',
      accessor: 'educator_logins',
      sortable: true,
    },
    {
      label: 'Student Logins',
      accessor: 'student_logins',
      sortable: true,
    },
    {
      label: 'Story Opens',
      accessor: 'story_opens',
      sortable: true,
      tooltip:
        'Number of times an elementary storybook or a secondary school human interest story was accessed by a user at this school',
    },
    {
      label: 'Lessons Accessed',
      accessor: 'lessons_accessed',
      sortable: true,
      tooltip: 'Total number of times an educator at this school accessed a lesson',
    },
    {
      label: 'Time on Platform (hrs)',
      accessor: 'time_on_platform',
      sortable: true,
      tooltip: 'Total time educators, admin and students, spent on the platform',
    },
  ];

  const totalsRow = getTotalRow(data);
  return <SortableTable data={data} columns={columns} totals={totalsRow} defaultSortField='educator_logins' />;
};

export default DistrictDataTable;
